// extracted by mini-css-extract-plugin
module.exports = {"data_routing_iframe":"DataRouting_data_routing_iframe__1uzuT"};